import { Component, OnInit, Inject, Renderer2, ElementRef, ViewChild, TemplateRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { Subscription } from 'rxjs/internal/Subscription';
import { OnDestroy } from '@angular/core/src/metadata/lifecycle_hooks';
import { TournamentService } from 'src/app/tournamentpopup/tournament.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { MainService } from 'src/app/_services/main.service';
import { AppState } from 'src/app/app.state';
import { Store } from '@ngrx/store';
import { MiniLobbyData, TournamentMiniLobbyData, UserBalanceData } from 'src/app/store/actions/appActions';
import { DeviceDetectorService } from 'ngx-device-detector'; 
import { InviteFriendsComponent } from '../components/invite-friends/invite-friends.component';
import { ConfirmboxComponent } from 'src/app/confirmbox/confirmbox.component';
import { NgxSpinnerService } from 'ngx-spinner';
declare var $: any;  
declare var window: any;  
@Component({
  selector: 'app-league-reg-popup',
  templateUrl: './league-reg-popup.component.html',
  styleUrls: ['./league-reg-popup.component.scss'],
  animations: [
    trigger('fadeInOut', [
      state('void', style({
        height: 0
      })),
      transition('void <=> *', animate(100)),
    ]),
    
  ]
})
export class LeagueRegPopupComponent implements OnInit, OnDestroy {
  joinForm: FormGroup;
  assetURL: string;
  submitted = false;
  public show_phone = false;
  parameters: any;
  currentUser: any;
  result: any;
  user_id = 0;
  sub_result: Subscription;
  sub_joinLeague: Subscription;
  isMobile = false;
  countNumber=0;
  selectCounter = [1,2,3,4,5,6,7,8,9,10];
  drafttype_id = 1;
  tournament_code = '';
  confirmDialogRef: MatDialogRef<ConfirmboxComponent>;
  second_per_pick = 0;
  use_ticket = 0;
  is_campaign = "0";
  darkMode= false;
  darkMode_ext= '';
  phpUrl = `${environment.phpUrl}`;
  @ViewChild('mobileApp') mobileApp: TemplateRef<any>;
  constructor( @Inject(MAT_DIALOG_DATA) private popupData,private _appService: MainService, public dialog: MatDialog, public leagueDialogRef: MatDialogRef<LeagueRegPopupComponent>,private tournamentService: TournamentService,private formBuilder: FormBuilder,private router: Router, private store: Store<AppState>,private deviceService: DeviceDetectorService, private renderer:Renderer2, private elementRef:ElementRef, public inviteFriendsDialogRef: MatDialogRef<InviteFriendsComponent>,private spinner: NgxSpinnerService) {
    this.isMobile = this.deviceService.isMobile();
    this.parameters = popupData;
    this.result = this.parameters.result;
    this.result.league_id = this.parameters.league_id;
    if(this.result.max_multijoin != null) {
      const multijoinArray = Array.from(Array(this.result.max_multijoin+1).keys());
      this.selectCounter = multijoinArray.slice(1,multijoinArray.length);
    }
    this.selectCounter = this.validateMaxEntries();

    if (this.parameters.drafttype_id != null) this.drafttype_id = this.parameters.drafttype_id;
    if (this.parameters.tournament_code) this.tournament_code = this.parameters.tournament_code;
    if (this.result.draft_speed_set) this.second_per_pick = this.result.draft_speed_set[0]['value'];
    if (this.result.ticket) this.use_ticket = this.result.ticket.checked;
    this.store.select('DarkModeReducer').subscribe(state => {
      if (state.length > 0) {
        this.darkMode = state[0].isDarkMode;
        this.darkMode_ext = this.darkMode?'_icon-dark':'';
      }
    });
  }

  ngOnInit() {
    this.assetURL = `${environment.assetURL}`;
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (this.currentUser != null) {
      this.user_id = this.currentUser.id;
      this.countNumber = 0;
    }

    this.joinForm = this.formBuilder.group({
      msg_send: [false, ''],
      league_code: [this.parameters.league_code, ''],
      draft_type: [this.parameters.draft_type, ''],
      user_id: [this.user_id, ''],
      phone_number: ['', [Validators.minLength(10),Validators.maxLength(12)]],
      /*multi_entry: [false],*/
      counter: ['1'],
      assigned_rank: ['0', ''],
      ip: [''],
      second_per_pick: this.second_per_pick,
      ticket_id: 0,
      use_ticket: this.use_ticket
    });
    this.getJoinData();
    this.getIpAddress();
    /**Load Jquery for hubzity event tracking */
    if(!this.checkJqueyLoaded() && this.is_campaign == "1") {
      const script = this.renderer.createElement('script');
      script.src = 'https://ajax.googleapis.com/ajax/libs/jquery/1.7.1/jquery.min.js';
      script.onload = () => {
        console.log('script loaded');
      };
      document.getElementsByTagName( "head" )[0].appendChild(script);
     // document.getElementsByTagName( "head" )[0].appendChild( script );

    }
  }

  // convenience getter for easy access to form fields
  get f() { return this.joinForm.controls; }

  smsToggle() {
    this.show_phone = !this.show_phone;
    const phone_number = this.joinForm.get('phone_number');
    this.joinForm.get('msg_send').valueChanges
      .subscribe(status => {
        if (status) {
          phone_number.setValidators([Validators.required,Validators.minLength(12),Validators.maxLength(12)]);
        }else {
          phone_number.setValidators(null);
        }
        phone_number.updateValueAndValidity();
      });

    /* if (this.show_phone) {
      phone_number.setValidators([Validators.minLength(12),Validators.maxLength(12)]);
    }else{
      phone_number.setValidators(null);
    }
    
    phone_number.updateValueAndValidity(); */
  }
  
  counterChange() {
    // Calculate total entry fees when user change the number of drafts
    if(this.joinForm.get('counter').value > 0) {
      this.result.entry_fee = this.result.currency + this.roundNumber(this.result.league_fee * this.joinForm.get('counter').value, 1);
      if(this.joinForm.get('counter').value > 1)  this.result.entry_fee +=  " (" + this.result.currency + this.roundNumber(this.result.league_fee, 1) + " x " + this.joinForm.get('counter').value + ")";
    }
    return true;
  }
  
  validateMaxEntries() {
    // Validate max number of possible entries user can make to join particular draft
    const maxPossibleJoin = this.roundNumber(this.result.balance/this.result.league_fee, 0);
    return this.selectCounter.slice(0, maxPossibleJoin);
  }

  ticketToggle() {
    this.joinForm.get('use_ticket').valueChanges
      .subscribe(status => {
        if (status) {
          this.use_ticket = 1;
          this.joinForm.controls['ticket_id'].setValue(this.result.ticket.ticket_id);
        }
        else {
          this.use_ticket = 0;
          this.joinForm.controls['ticket_id'].setValue(0);
        }
      });
  }

  keyPress(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    const phonel:string = this.f.phone_number.value; 
    const inputChar = String.fromCharCode(event.charCode);
    if ((event.keyCode !== 8 && !pattern.test(inputChar)) || phonel.length > 11) {
      event.preventDefault(); 
    }else{ 
      const countNumber = (this.f.phone_number.value)?phonel.length:0; 
      if(countNumber === 3 || countNumber === 7){
        const phone_number = this.f.phone_number.value+'-';
        this.joinForm.controls['phone_number'].setValue(phone_number);
      }
    }
  }

  getJoinData() {
    if (this.result) {
      if (this.result.ranking_set) {
        let is_default = false;
        this.result.ranking_set.forEach(element => {
          if (element.is_default === 1) {
            is_default = true;
            this.joinForm.controls['assigned_rank'].setValue(element.value.toString());
          }
        });
        if(!is_default){
          this.joinForm.controls['assigned_rank'].setValue('0');
        }
      }
      
      if (this.result.draft_speed_set && this.result.draft_speed_set.length > 1) {
        let active = false;
        this.result.draft_speed_set.forEach(element => {
          if (element.active === 1) {
            active = true;
            this.joinForm.controls['second_per_pick'].setValue(element.value.toString());
          }
        });
        if(!active){
          this.joinForm.controls['second_per_pick'].setValue(0);
        }
      }
      else {
        this.joinForm.controls['second_per_pick'].setValue(this.second_per_pick);
      }
      
      if (this.result.show_phone) {
        this.show_phone = this.result.show_phone;
        this.joinForm.controls['msg_send'].setValue(true);
      }
      else {
        this.show_phone = this.result.show_phone;
        this.joinForm.controls['msg_send'].setValue(false);
        //this.joinForm.controls['phone_number'].setValue('');
      }
      this.joinForm.controls['phone_number'].setValue(this.result.phone_number);
      
      if (this.use_ticket) {
        this.joinForm.controls['ticket_id'].setValue(this.result.ticket.ticket_id);
      }
    }
    /* if (this.parameters.league_code) {
      this.sub_result = this.tournamentService.getJoinPopUpData(this.parameters.league_code, this.user_id).subscribe(res => {
        if (typeof res !== 'undefined' && res.status === 'success') {
          this.result = res.entities;
          if (this.result.ranking_set) {
            this.result.ranking_set.forEach(element => {
              if (element.is_default === 1) {
                this.joinForm.controls['assigned_rank'].setValue(element.value);
              }
            });
          }
        }
      });
    } */
  }

  getIpAddress() { 
    this.tournamentService.getIpAddress(this.user_id).subscribe(
      data=>{
        this.joinForm.get('ip').setValue(data.ip)
      }
    )
  }
 
  onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.joinForm.invalid) {
      return;
    } else {
      this.spinner.show();
      this.sub_joinLeague = this.tournamentService.joinLeague(this.joinForm.value).pipe(first()).subscribe(
        data => {
          this.submitted = false;
          this.spinner.hide();
          if (data.status === 'success') {
            /**Update user balance */
            if(this.joinForm.value.ticket_id == 0) {
              this.result.balance = parseFloat(this.result.balance) - parseFloat(this.result.league_fee);
              this.store.dispatch(new UserBalanceData(
                this.result.balance
              ));
            }
            if(this.f['counter'].value && this.f['counter'].value > 1){
              this.parameters.league_id = data.fantasy_lg_id;
              this.parameters.league_code = data.league_code;
              this.joinMultiEntry();
            }
            this.hideModalBox((this.drafttype_id < 4)?null:data);
            if (this.drafttype_id < 4){
              setTimeout(() => {
                if(data.is_full === true){ 
                  //this.router.navigate(['/draft/' + this.result.league_id]);
                }else{ 
                  const rannkUrl = `${environment.SITE_URL}`+'/draft/ranking/'+this.result.league_type+'/'+data.league_code;
                  if (this.tournament_code != '') {
                    var inviteUrl = `${environment.SITE_URL}`+'/tournament/'+this.result.league_type+'/'+this.tournament_code+'?invite=yes';
                  }
                  else {
                    var inviteUrl = `${environment.SITE_URL}`+'/league/profile/'+this.result.league_type+'/'+data.league_code+'?invite=yes'; 
                  }
                  const body = data.message;
                  this.inviteFriendsDialogRef = this.dialog.open(InviteFriendsComponent, {
                    width:'460px',
                    data: { 'body': body, 'invite_url': inviteUrl, 'ranking_url': rannkUrl,'fantasy_lg_id':data.fantasy_lg_id,'rem_entratns':data.rem_entratns,'entrants':data.entrants}
                  });
                  /* const rannkUrl = `${environment.SITE_URL}`+'/draft/ranking/'+this.result.league_type+'/'+data.league_code; 
    
                  window.location.href = rannkUrl; */
                }
              }, 500);
            }
            //this.refreshJoinDraftMiniLobby();
            if(this.is_campaign == "1") this.trackHubZityEvents("6");
          } 
          else if (data.status == 'failure') {
            this.leagueDialogRef.close((this.drafttype_id < 4)?0:data);
            this.confirmDialogRef = this.dialog.open(ConfirmboxComponent, {
              width: '500px',
              data: { 'title': "Warning", 'body': data.message,'type':'alert-box' }
            });
            
            this.confirmDialogRef.afterClosed()
            .subscribe(res => {
              if (res) {}
            })
          }
          else { 
            this.leagueDialogRef.close((this.drafttype_id < 4)?0:data);  
          } 
        },
        error => {
          this.submitted = false;
          this.leagueDialogRef.close(0);  
          console.log(error);
        });
    }
  }

  // submit multi entry
  joinMultiEntry(){
    const formData = {league_id:this.parameters.league_id,league_code:this.parameters.league_code,common_rank_id:this.f['assigned_rank'].value,user_id:this.user_id,ip:'',msg_send:this.f['msg_send'].value,phone_number:this.f['phone_number'].value,counter:this.f['counter'].value - 1,tournament_id: (this.parameters.result.tournament_id != null) ? this.parameters.result.tournament_id : 0, second_per_pick: this.f['second_per_pick'].value };
    //Counter reduced by 1 as 1 entry has already done on first join
    this.sub_joinLeague = this.tournamentService.joinMultiEntry(formData).pipe(first()).subscribe(
      data => {
    });
  }

  refreshJoinDraftMiniLobby() {
    if (this.parameters.draft_type === 'league') {
      this._appService.getActiveLeague(this.user_id, 0)
        .subscribe(res => { 
          this.store.dispatch(new MiniLobbyData(
            res.result
          ));
        }, err => {
          console.log(err);
        });
    } else if (this.parameters.draft_type === 'tournament') {
      this._appService.getActiveDraft(this.user_id, 'all')
        .subscribe(res => {
          if (res.result) {
            this.store.dispatch(new TournamentMiniLobbyData(
              res.result
            ));
          }
        }, err => {
          console.log(err);
        });
    }
  }

  hideModalBox(data = null) {
    this.leagueDialogRef.close((data == null)?1:data);
    //this.dialog.closeAll();
  }

  roundNumber(number,decimalPlace) {
    const decimal = Math.pow(10, decimalPlace);
    return Math.floor(number * decimal) / decimal
  }

  
 trackHubZityEvents(TRACKING_CONVERSION_STAGE){
    /* Hubzity conversion stage tracking start */
    if (window.trackingStoreSession !== undefined && window.trackingConversion !== undefined) {
      window.trackingStoreSession();
      window.trackingConversion(TRACKING_CONVERSION_STAGE);
    } else {
      var head = document.getElementsByTagName("head")[0];
      var trackingScript = document.createElement("script");
      
      trackingScript.setAttribute("async", 'true');
      trackingScript.setAttribute("src", "//static.rtbaxs.io/tracking.min.js?ts=" + new Date().getTime());
      
      trackingScript.addEventListener("load", function () {
        window.trackingStoreSession();
        window.trackingConversion(TRACKING_CONVERSION_STAGE); //use this in each following pages in case you want to track their loading
      });
      
      trackingScript.addEventListener("error", function () {
        console.log("Failed to load Hubzity tracking SDK");
      });
      
      head.appendChild(trackingScript);
    }
    /* Hubzity conversion stage tracking end */
  }

  checkJqueyLoaded() {
    let isFound = false;
    let scripts = document.getElementsByTagName("script")
    for (let i = 0; i < scripts.length; ++i) {
        if (scripts[i].getAttribute('src') != null && scripts[i].getAttribute('src').includes("jquery.min.js")) {
            isFound = true;
        }
    }
    //console.log("jquery loaded:",isFound);
    return isFound;
  }

  ngOnDestroy() {
    // this.sub_joinLeague.unsubscribe();
    // this.sub_result.unsubscribe();
  }
  openAppPopup(tlgid) {
    this.confirmDialogRef = this.dialog.open(this.mobileApp, {
      width: this.isMobile?'90%':'50%',
      data: { }
    });
    
    this.confirmDialogRef.afterClosed()
    .subscribe(res => {})
  }
}
